export default (valueToCheck) => {
  try {
    return (typeof valueToCheck === "string" && Array.isArray(JSON.parse(valueToCheck)))
      || Array.isArray(valueToCheck)
  } catch (e) {
    return false
  }
}
